import { render, staticRenderFns } from "./NominationAgeProof.vue?vue&type=template&id=52042e95&scoped=true"
import script from "./NominationAgeProof.vue?vue&type=script&lang=js"
export * from "./NominationAgeProof.vue?vue&type=script&lang=js"
import style0 from "./NominationAgeProof.vue?vue&type=style&index=0&id=52042e95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52042e95",
  null
  
)

export default component.exports